import { Button } from 'components'
import Flex from 'components/priority/Flex/Flex'
import Text from 'components/priority/Text/Text'
import { useNavigate } from 'hooks'
import { useLocation } from 'react-router-dom'
import buildUrlWithParams from 'utils/global/buildUrlWithParams'
import { useTranslation } from 'react-i18next'

export const UnsavedModal = ({ setShow, orderId }) => {
  const navigate = useNavigate()
  const location = useLocation()
  const params = new URLSearchParams(location.search)
  const { t } = useTranslation()
  const handleBack = () => {
    setShow()
    navigate(buildUrlWithParams(`/package/${orderId}/customize`, params))
  }
  return (
    <Flex column full padding="32px">
      <Text size="20px" weight="600" margin="10px 0 10px 0">
        {t('editor.unsavedProgressModal.warningText')}
      </Text>
      <Flex justify="flex-end" margin="10px 0 0 0">
        <Button
          data-testid="unsaved-modal-cancel"
          margin="0 16px 0 0"
          onClick={setShow}
        >
          {t('editor.unsavedProgressModal.cancelButton')}
        </Button>
        <Button
          data-testid="unsaved-modal-exit"
          secondary
          margin="0 16px 0 0"
          onClick={() => handleBack()}
        >
          {t('editor.unsavedProgressModal.exitButton')}
        </Button>
      </Flex>
    </Flex>
  )
}

export default UnsavedModal
